import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'

export const isUrl = (url: string): boolean =>
  /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/.test(url)
export const onlyHttps = (url: string): boolean => /(https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&:/~+#]*[\w\-@?^=%&/~+#])?/.test(
  url
)

export const zhjaReg = '\u4e00-\u9fa5|\u3040-\u309f|\u30a0-\u30ff'

export const isName = (url: string): boolean =>
  /^.{1,18}$/.test(url)

export const isContractName = (url: string): boolean =>
  /^.{1,18}$/.test(url)

// 防抖

// 最小延迟
export function wait<T> (
  time = 1000,
  promise: Promise<T> | void = undefined
): Promise<T | string> {
  let delay: Promise<T | string> = new Promise((resolve) => {
    setTimeout(() => {
      resolve('')
    }, time)
  })
  if (promise instanceof Promise) {
    delay = Promise.all([promise, delay]).then((res) => res[0])
  }
  return delay
}

// 添加金额分隔符
export function formatMoney (num: number | string | void, returnVal = true): string {
  // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  if (num !== 0 && (!num || isNaN(Number(num)))) return ''
  return returnVal ? (Math.round(Number(num) * 100) / 100).toLocaleString('en-us').replace(/(\.\d\d)\d$/, '$1') : num.toLocaleString('en-us')
}

// 遍历对象
export function forObj (obj: any, fn: any): void {
  Object.entries(obj).forEach(([k, v]) => {
    fn(obj, k, v)
  })
}

export function forObjVal (obj: any, fn: any): void {
  forObj(obj, (obj: any, k: any, v: any) => (obj[k] = fn(v)))
}

export function encodeParams (params: any): any {
  forObjVal(params, encodeURIComponent)
  return params
}

export function decodeParams (params: any): any {
  forObjVal(params, decodeURIComponent)
  return params
}

// 反序列化
export function reserize (str = location.search, fn = (v: any) => v): any {
  str = str.replace(/^\?/, '')
  const obj: any = {}
  str.split('&').forEach((i) => {
    const [k, v] = i.split('=')
    obj[k] = fn ? fn(v) : v
  })
  return obj
}

// 序列话
export function serialize (obj: any, fn = (v: any) => v): any {
  const arr: any = []
  forObj(obj, (obj: any, k: any, v: any) => {
    arr.push(`${k}=${fn(v)}`)
  })
  return arr.join('&')
}

// arr2map
export function arr2map<T> (proplist: T[], propfn = (v: T) => v): Map<any, T> {
  const map = new Map()
  proplist.forEach((v) => {
    map.set(propfn(v), v)
  })
  return map
}

// 对比两个对象的原始值是否相等
export function isdeepsame (obj1: any, obj2: any): boolean {
  let same = false
  if (typeof obj1 === typeof obj2) {
    if (typeof obj1 === 'object' && obj1 !== null && obj2 !== null) {
      if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false
      }
      same = Object.entries(obj1).every(([k, v]) => {
        return isdeepsame(v, obj2[k])
      })
    } else {
      same = obj1 === obj2
    }
  }
  return same
}

// 格式化文章阅读量
export function formatViewNum (num: number) {
  if (isNaN(num)) {
    return 0
  } else if (num > 10000) {
    return (num / 10000).toFixed(1) + 'W'
  } else {
    return num
  }
}

export function copyText (text: string) {
  const textarea = document.createElement('textarea')
  textarea.value = text
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('Copy')
  document.body.removeChild(textarea)
  ElMessage.success(t('复制成功'))
}

/**
 * 是否包含emoj表情
 * @param substring
 * @returns
 */
export function isEmojiCharacter (substring: string): boolean {
  for (let i = 0; i < substring.length; i++) {
    const hs = substring.charCodeAt(i)
    if (hs >= 0xd800 && hs <= 0xdbff) {
      if (substring.length > 1) {
        const ls = substring.charCodeAt(i + 1)
        const uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000
        if (uc >= 0x1d000 && uc <= 0x1f77f) {
          return true
        }
      }
    } else if (substring.length > 1) {
      const ls = substring.charCodeAt(i + 1)
      if (ls === 0x20e3) {
        return true
      }
    } else {
      if (hs >= 0x2100 && hs <= 0x27ff) {
        return true
      } else if (hs >= 0x2B05 && hs <= 0x2b07) {
        return true
      } else if (hs >= 0x2934 && hs <= 0x2935) {
        return true
      } else if (hs >= 0x3297 && hs <= 0x3299) {
        return true
      } else if (hs === 0xa9 || hs === 0xae || hs === 0x303d || hs === 0x3030 ||
        hs === 0x2b55 || hs === 0x2b1c || hs === 0x2b1b ||
        hs === 0x2b50) {
        return true
      }
    }
  }
  return false
}

/**
 * 获取cookie信息
 * @param name
 * @returns
 */
export function getCookie (name:string) {
  // 拆分 cookie 字符串
  const cookieArr = document.cookie.split(';')

  // 循环遍历数组元素
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=')
    /* 删除 cookie 名称开头的空白并将其与给定字符串进行比较 */
    if (name === cookiePair[0].trim()) {
      // 解码cookie值并返回
      return decodeURIComponent(cookiePair[1])
    }
  }
  // 如果未找到，则返回null
  return null
}

export function addWWWtoURL (url:string) {
  // 先检查URL是否已经包含 "www."
  if (url.includes('www.')) {
    return url
  }

  // 检查URL是否包含 "http://" 或 "https://"
  const hasProtocol = url.startsWith('http://') || url.startsWith('https://')

  // 根据是否有协议,添加"www."
  if (hasProtocol) {
    return url.replace(/^(http(s)?:\/\/)/, '$1www.')
  } else {
    return 'www.' + url
  }
}
